import React, { useCallback, useEffect, useRef } from "react";
import { Animated, View } from "react-native";
import { Easing } from "react-native-reanimated";
import { ANIMATION_DURATION, MAX_ROTATION, MIN_ROTATION } from "./constants";

export type JiggleViewProps = {
  jiggle?: boolean;
  children?: React.ReactNode;
};

const commonAnimationConfig = {
  useNativeDriver: true,
  duration: ANIMATION_DURATION,
};

export function JiggleView({ jiggle = false, children }: JiggleViewProps) {
  const anim = useRef(
    new Animated.Value(0, { useNativeDriver: false })
  ).current;

  const interpolateRotating = anim.interpolate({
    inputRange: [-1, 1],
    outputRange: [MIN_ROTATION, MAX_ROTATION],
  });

  const animatedStyle = {
    transform: [
      {
        rotate: interpolateRotating,
      },
    ],
  };

  const rotateLeft = Animated.timing(anim, {
    ...commonAnimationConfig,
    easing: Easing.ease,
    toValue: -1,
  });

  const rotateRight = Animated.timing(anim, {
    ...commonAnimationConfig,
    easing: Easing.ease,
    toValue: 1,
  });

  const rotateNeutral = Animated.timing(anim, {
    ...commonAnimationConfig,
    toValue: 0,
  });

  const startJiggle = useCallback(() => {
    Animated.loop(
      Animated.sequence([rotateLeft, rotateRight, rotateNeutral])
    ).start();
  }, []);

  useEffect(() => {
    if (jiggle) {
      startJiggle();
    } else {
      anim.stopAnimation();
    }
  }, [jiggle]);

  return (
    <Animated.View style={animatedStyle}>
      <View>{children}</View>
    </Animated.View>
  );
}
